import styled, { keyframes } from 'styled-components'
import withTheme from '@/components/withTheme'

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  height: var(--vh);
  background: rgba(0, 0, 0, 0.85);
  z-index: 99999;
`

const spinClockWise = keyframes`
  0% {
    transform: translate(-50%, -50%) rotate(0deg) scale(1);
  }

  50% {
    transform: translate(-50%, -50%) rotate(180deg) scale(1.5);
  }

  100% {
    transform: translate(-50%, -50%) rotate(360deg) scale(1);
  }
`

const spinCounterClockWise = keyframes`
  0% {
    transform: translate(-50%, -50%) rotate(0deg) scale(1);
  }

  50% {
    transform: translate(-50%, -50%) rotate(-180deg) scale(0.5);
  }

  100% {
    transform: translate(-50%, -50%) rotate(-360deg) scale(1);
  }
`

interface SpinnerProps {
  size?: number
  offsetTop?: number
  offsetLeft?: number
  color?: string
  clockWise?: number | boolean
  duration?: number
}

const Spinner = styled.div<SpinnerProps>`
  position: absolute;
  width: ${({ size }) => size}vw;
  height: ${({ size }) => size}vw;
  top: ${({ offsetTop }) => 50 + (offsetTop ?? 0)}%;
  left: ${({ offsetLeft }) => 50 + (offsetLeft ?? 0)}%;
  transform: translate(-50%, -50%);
  border: 3px solid rgb(${({ color }) => color});
  border-left: none;
  border-top: none;
  border-radius: 100%;
  animation: ${({ clockWise }) => clockWise ? spinClockWise : spinCounterClockWise} ${({ duration }) => duration}ms linear infinite;
`

;(Spinner as any).defaultProps = {
  size: 50,
  duration: 1000,
  clockWise: true,
  color: '255,255,255'
}

export default withTheme(({ theme }: { theme: any }) => {
  return (
    <Container>
      {[...Array(15)].map((_, i) => {
        const props = {
          size: 2.5 * (i + 1),
          duration: 200 * (i + 1),
          clockWise: i % 2,
          color: theme.color[i % 2 ? 'primary' : 'action'],
          offsetTop: 0,
          offsetLeft: 0
        }

        return <Spinner key={i} {...props} />
      })}
    </Container>
  )
})
